import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    dropdownIcon: {
      top: '7px',
      left: '-4px',
      marginRight: '4%',
      color: 'black',
      cursor: 'pointer',
    },
    taskGroupHeader: {
      display: 'inline-flex',
      alignItems: 'center',
      color: '#3C419A',
      fontWeight: 700,
      fontSize: '1em',
    },
    subHeader: {
      display: 'inline-flex',
      alignItems: 'center',
      fontWeight: 700,
      cursor: 'pointer',
      fontSize: '14px',
    },
    filterListIcon: {
      position: 'relative',
      top: '1px',
      left: '-1px',
      width: '1.5rem',
      padding: '2px',
      cursor: 'pointer',
    },
    actionIcon: {
      position: 'relative',
      top: '1px',
      color: '#3C419A',
      cursor: 'pointer',
    },
    columnWithLockIcon: {
      position: 'relative',
    },
    lockIcon: {
      '&.MuiSvgIcon-root': {
        borderRadius: '20px',
        width: '15px',
        height: '15px',
        color: '#BC0000',
        position: 'absolute',
        padding: '5px',
        right: '20px',
        '&:hover': {
          backgroundColor: '#EFDADA',
        },
      },
    },
    autolockIconDiv: {
      width: '15px',
      height: '15px',
      color: '#BC0000',
      position: 'absolute',
      padding: '5px',
      bottom: '0',
      right: '20px',
      '&:hover': {
        backgroundColor: '#EFDADA',
        borderRadius: '20px',
      },
    },
    autolockIcon: {
      width: '15px',
      height: '15px',
      color: '#BC0000',
      position: 'absolute',
      padding: '5px',
      right: '0px',
      bottom: '1px',
    },
  }),
);
